<template>
  <div>
    <HeaderReceipt header="แก้ไขข้อมูลใบเสร็จ" :img_header="header_image" link_back="stock/storage/addproducttostock"/>
    <StoragePR_edit/>
  </div>
</template>

<script>
import HeaderReceipt from "@/components/admin/stock/menustorage/HeaderReceipt";
import HeaderImage from "@/assets/verified.png";
import StoragePR_edit from "@/components/admin/stock/pr/StoragePR_edit";
export default {
  name: "PrEdit",
  data() {
    return {
      header_image: HeaderImage
    }
  },
  components: {
    StoragePR_edit,
    HeaderReceipt
  }
}
</script>

<style scoped>

</style>
